<template>
  <div>
    <PageAllow controller="StockMaterialHistories" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRange
                type="datetime"
                v-model="datetimeRage"
                :label="$t('StockMaterialHistories.Fields.created_time')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量导出 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'StockMaterialHistories',
                    'batchDetailExport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="batchExportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("StockMaterialHistories.Fields.batchDetailExport") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 仓库中心 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStock v-model="stockSelected" :stock-types="[0]" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stock_material_histories"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.created="{ item }">
              <span>
                {{ item.created | formatTime }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- 明细 -->
              <v-tooltip
                top
                v-if="
                  $permission.permissionAllow('StockMaterialHistories', 'view')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    dark
                    color="info"
                    class="px-2 me-2 mb-1"
                    :href="
                      '/#/current-stocks/detail/stock-material-history-details/' +
                      item.id
                    "
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("Opt.details") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("StockMaterialHistories.objectName")])
                }}</span>
              </v-tooltip>
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'StockMaterialHistories',
                    'export'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel(item.id)"
              >
                {{ $t("StockMaterialHistories.Fields.export") }}
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import stockMaterialHistories from "@/api/stock_material_histories";
import SearcherStock from "@/components/plugins/SearcherStock";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  stock_id: "",
};

export default {
  name: "stockDetails",

  data: () => ({
    stock_material_histories: [],
    stockSelected: {},
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("stock_material_history-options")
        ? sessionStorage.getItem("stock_material_history-options")
        : JSON.stringify(defaultOptions)
    ),
    datetimeRage: [
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
  }),

  components: {
    Breadcrumbs,
    SearcherDatetimeRange,
    PageAllow,
    SearcherStock,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.currentStocks"),
        disabled: false,
        href: "/current-stocks",
      },
      {
        text: i18n.t("StockMaterialHistories.objName"),
        disabled: true,
        href: "/current-stocks/detail/stock-material-history",
      },
    ],
    headers: () => [
      {
        text: i18n.t("StockMaterialHistories.Fields.stockName"),
        align: "start",
        sortable: false,
        value: "stock.name",
      },
      {
        text: i18n.t("StockMaterialHistories.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("StockMaterialHistories.Fields.created_name"),
        align: "start",
        sortable: false,
        value: "created_name",
      },
      // 操作
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("stock_material_history", ["stockSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.datetimeRage = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stockSelected":
                this.stockSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.stockSelected = {};
      this.datetimeRage = [
        new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getStockMaterialHistoriesFromAPI() {
      // this.id = this.$route.query.stock_id;
      stockMaterialHistories.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_material_histories =
              response.data.stock_material_histories;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    exportExcel(id) {
      stockMaterialHistories.exports({ keyword: "", id: id });
    },
    batchExportExcel() {
      stockMaterialHistories.batchDetailExport(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockMaterialHistoriesFromAPI();
        sessionStorage.setItem(
          "stock_material_history-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 仓配中心搜索
    stockSelected: {
      handler() {
        this.options.stock_id = this.stockSelected ? this.stockSelected.id : "";
        sessionStorage.setItem(
          "stock_material_history-stockSelected",
          JSON.stringify(this.stockSelected)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
  },
};
</script>

<style>
</style>